import { ICalcs } from '../constants/queryCreation.interface';

/**
 * Used for sorting calcs list by description
 * @param a
 * @param b
 * @returns number
 */
export const sortByDescription = (a: ICalcs, b: ICalcs): number => {
  const descriptionA = a.description || '';
  const descriptionB = b.description || '';
  return descriptionA.localeCompare(descriptionB);
};
